import Modal from "components/modal";
import ModalTemplate from "components/modal/modal-template";
import Typography from "components/typography";
import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import api from "services/axiosInstance";
import { CreateSplitSheet } from "services/uploadMusic/createSplitSheet";
import { UpdateSplitSheet } from "services/uploadMusic/updateSplitSheet";
import { IMusicData } from "types/musicData";
import { Colors } from "utils/colors";
import { EditMetadata } from "./editMetadata";
import Toast from "components/toast";

interface IProps {
  finish: boolean;
  musicData: IMusicData;
  trackId: string;
  close: () => void;
}
const FinishModal = ({ finish, musicData, close, trackId }: IProps) => {
  const [loading, setLoading] = useState(false);
  const navigate = useNavigate();
  const Confirm = async () => {
    if (trackId) {
      setLoading(true);

      try {
        const res = await EditMetadata(musicData, trackId);

        for (const track of musicData.trackList) {
          if (track.split && track.splitSheetId) {
            await UpdateSplitSheet(track.split, track.splitSheetId);
          } else if (track.split && !track.splitSheetId) {
            await CreateSplitSheet(track.split, trackId);
          }
        }

        if (res && musicData.releaseType === "SINGLE") {
          navigate(`/overview/discography/track/${trackId}?type=SINGLE`);
        } else if (res && musicData.releaseType !== "SINGLE") {
          navigate(`/overview/discography/track/${trackId}?type=CONTAINER`);
        }
      } catch (error) {
        Toast({ error });
      } finally {
        setLoading(false);
      }
    }
  };
  return (
    <Modal isActive={finish} closeModal={close}>
      <ModalTemplate
        close={close}
        header="Submit Edit Request?"
        confirm={Confirm}
        twoButtons
        confirmText="confirm"
        cancelText="cancel"
        loading={loading}
      >
        <Typography
          align="center"
          color={Colors.grey400}
          weight="medium"
          size="lg"
        >
          You won’t be able to submit another edit request for this release
          until this request has been reviewed
        </Typography>
      </ModalTemplate>
    </Modal>
  );
};

export default FinishModal;
